module.exports = __webpack_public_path__ + "static/media/evgenia.8f15a121.png";